import { Component, Injectable } from "@angular/core";
import { NetworkService } from "src/app/data/services/network.service";
import { SnackBarComponent } from "../snack-bar/snack-bar.component";

@Component({
  selector: 'app-network-snackbar',
  template: '',
})
export class NetworkSnackbarComponent {
  constructor(
    private readonly networkService: NetworkService,
    private readonly snackBar: SnackBarComponent,
  ) {}

    ngOnInit(): void {
      this.networkService.isOnline$.subscribe(isOnline => {
        if (!isOnline) {
          this.snackBar.errorSnackBar('Sem conexão com a internet');
        } else {
          this.snackBar.closeSnackBar();
        }
      });
    }

}
